import { SchedulerForm } from './scheduler-form';

export default {
  tag: 'schedulerform',
  format: '<SchedulerForm />',
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    return <SchedulerForm {...props} />;
  },
};
